import AnnouncementTypes, { Announcement, UserAnnouncement } from "./announcement.types";
import { ThunkDispatch } from "redux-thunk";
import RootState from "store/state";
import * as AnnouncementAPI from '../../services/api/api.announcement';
import { IStrObj } from "utils";

export type AnnouncementAction =
    | { type: typeof AnnouncementTypes.GET_USER_ANNOUNCEMENTS; payload: UserAnnouncement[]}
    | { type: typeof AnnouncementTypes.GET_UNREAD_USER_ANNOUNCEMENTS; payload: UserAnnouncement[]}
    | { type: typeof AnnouncementTypes.UPDATE_USER_ANNOUNCEMENT; payload: Partial<UserAnnouncement>}
    | { type: typeof AnnouncementTypes.UPDATE_USER_ANNOUNCEMENT_LOADING; payload: boolean }
    | { type: typeof AnnouncementTypes.GET_ANNOUNCEMENTS; payload: Announcement[]}
    | { type: typeof AnnouncementTypes.GET_ANNOUNCEMENTS_LOADING }
    | { type: typeof AnnouncementTypes.GET_ANNOUNCEMENTS_ERROR }
    | { type: typeof AnnouncementTypes.UPDATE_ANNOUNCEMENT; payload: Announcement }
    | { type: typeof AnnouncementTypes.UPDATE_ANNOUNCEMENT_LOADING; payload: boolean }
    | { type: typeof AnnouncementTypes.CREATE_ANNOUNCEMENT_LOADING; payload: boolean }
    | { type: typeof AnnouncementTypes.DELETE_ANNOUNCEMENT; payload: string }


export function getMyUserAnnouncements(filters?: IStrObj) {
    return async (
        dispatch: ThunkDispatch<RootState, undefined, AnnouncementAction>,
        getState: () => RootState
    ) => {

        try {
            const companyID = getState().app.ID;
            const instanceID = getState().app.instance?.ID!;
            const token = getState().auth.token!;

            const userAnnouncements = await AnnouncementAPI.getMyUserAnnouncements(
                companyID,
                instanceID,
                token,
                filters,
            );

            dispatch({
                type: AnnouncementTypes.GET_USER_ANNOUNCEMENTS,
                payload: userAnnouncements
            })

        } catch (error) {
            console.log("error getting user announcements")
        }
    }
}

export function getMyUnreadUserAnnouncements() {
    return async (
        dispatch: ThunkDispatch<RootState, undefined, AnnouncementAction>,
        getState: () => RootState
    ) => {

        try {
            const companyID = getState().app.ID;
            const instanceID = getState().app.instance?.ID!;
            const token = getState().auth.token!;

            const unreadUserAnnouncements = await AnnouncementAPI.getMyUserAnnouncements(
                companyID,
                instanceID,
                token,
                {
                    read: '0'
                }
            );

            dispatch({
                type: AnnouncementTypes.GET_UNREAD_USER_ANNOUNCEMENTS,
                payload: unreadUserAnnouncements
            })

        } catch (error) {
            console.log("error getting user announcements")
        }
    }
}

export function getAnnouncements() {
    return async (
        dispatch: ThunkDispatch<RootState, undefined, AnnouncementAction>,
        getState: () => RootState
    ) => {

        try {
            dispatch({
                type: AnnouncementTypes.GET_ANNOUNCEMENTS_LOADING,
                payload: true
            });

            const companyID = getState().app.ID;
            const instanceID = getState().app.instance?.ID!;
            const token = getState().auth.token!;

            const announcements = await AnnouncementAPI.getAnnouncements(
                companyID,
                instanceID,
                token
            );

            dispatch({
                type: AnnouncementTypes.GET_ANNOUNCEMENTS,
                payload: announcements.data
            })

        } catch (error) {
            console.log("error getting announcements")
        }
    }
}

export function updateAnnouncement(announcement: Partial<Announcement>) {
    return async (
        dispatch: ThunkDispatch<RootState, void, AnnouncementAction>,
        getState: () => RootState
    ) => {
        const companyID = getState().app.ID;
        const instanceID = getState().app.instance?.ID!;
        const token = getState().auth.token!;

        try {

            const res = await AnnouncementAPI.putAnnouncement(
                companyID,
                instanceID,
                announcement,
                token
            );

            dispatch({
                type: AnnouncementTypes.UPDATE_ANNOUNCEMENT,
                payload: res
            });

            dispatch({
                type: AnnouncementTypes.UPDATE_ANNOUNCEMENT_LOADING,
                payload: false
            });
        } catch (err) {
            console.log("error updating announcement")
        }
    };
}

export function deleteAnnouncement(announcementID: string) {
    return async (
        dispatch: ThunkDispatch<RootState, void, AnnouncementAction>,
        getState: () => RootState
    ) => {
        const companyID = getState().app.ID;
        const instanceID = getState().app.instance?.ID!;
        const token = getState().auth.token!;

        try {
            dispatch({
                type: AnnouncementTypes.DELETE_ANNOUNCEMENT,
                payload: announcementID
            });

            await AnnouncementAPI.deleteAnnouncement(
                companyID,
                instanceID,
                announcementID,
                token
            );

        } catch (err) {
            console.log("error deleting announcement")
        }
    };
}
export function updateUserAnnouncement(ID: string, userAnnouncement: Partial<UserAnnouncement>) {
    return async (
        dispatch: ThunkDispatch<RootState, void, AnnouncementAction>,
        getState: () => RootState
    ) => {
        const companyID = getState().app.ID;
        const instanceID = getState().app.instance?.ID!;
        const token = getState().auth.token!;

        try {

            dispatch({
                type: AnnouncementTypes.UPDATE_USER_ANNOUNCEMENT,
                payload: {
                    ID,
                    ...userAnnouncement
                }
            });

            await AnnouncementAPI.putUserAnnouncement(
                companyID,
                instanceID,
                ID,
                userAnnouncement,
                token
            );

            dispatch({
                type: AnnouncementTypes.UPDATE_USER_ANNOUNCEMENT_LOADING,
                payload: false
            });
        } catch (err) {
            console.log("error updating announcement")
        }
    };
}

export function createAnnouncement(announcement: Partial<Announcement>) {
    return async (
        dispatch: ThunkDispatch<RootState, void, AnnouncementAction>,
        getState: () => RootState
    ) => {
        const companyID = getState().app.ID;
        const instanceID = getState().app.instance?.ID!;
        const token = getState().auth.token!;
        const announcements = getState().announcements.announcements!;

        try {
            const res = await AnnouncementAPI.postAnnouncement(
                companyID,
                instanceID,
                {
                    ...announcement,
                    ID: undefined,
                },
                token
            );

            dispatch({
                type: AnnouncementTypes.GET_ANNOUNCEMENTS,
                payload: [res, ...(announcements ?? [])]
            });

            dispatch({
                type: AnnouncementTypes.CREATE_ANNOUNCEMENT_LOADING,
                payload: false
            });
        } catch (err) {
            console.log("error creating announcement")
        }
    };
}